import React from "react";
import { useTheme } from "../hooks/useTheme";

const ThemeToggle = () => {
  const [theme, toggleTheme] = useTheme();

  return (
    <button
      type="button"
      className="pill-btn"
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      <i className={`fas ${theme === "dark" ? "fa-moon" : "fa-sun"}`} />
    </button>
  );
};

export default ThemeToggle;
